import { useQuery, gql } from "@apollo/client"

export const BULK_OFFBOARDING_QUERY = gql(`
  query BulkOffboardingQuery($bulkOffboardingId: ID!) {
    bulkOffboarding(bulkOffboardingId: $bulkOffboardingId) {
      id
      state
      company {
        id
      }
      terminations {
        id
        engagement {
          id
        }
      }
    }
  }
`)

export const useBulkOffboarding = (bulkOffboardingId: string) => {
  const { data, error, loading } = useQuery(BULK_OFFBOARDING_QUERY, {
    variables: { bulkOffboardingId },
  })

  return { data, error, loading }
}
